React = require 'react'
joinn = require 'joinn'
t = require('views/internal/recup-with-helpers')('enterprise_dashboard_bulk_actions_option')
_ = require 'underscore'

module.exports = class extends React.Component
  constructor: (props) ->
    super(props)

    @state = {
      showingMembersList: false
    }

  render: t.renderable ->
    { label, actionName, disabledMessage, members, onClick } = @props

    t.a
      class: t.classify 'disabled': (members.length == 0)
      onClick: onClick
    , =>
      t.span ->
        t.text label
      t.span '.sub-name', =>
        usernames = _.map members, (member) -> "@#{ member.username }"

        switch
          when usernames.length == 0
            t.text disabledMessage
          when usernames.length <= 3
            usernamesHeadline = joinn usernames, ', ', " #{ t.l('and') } "
            t.text "#{ actionName } #{ usernamesHeadline }"
          else
            usernames = _.first usernames, 2
            t.format 'more-than-three-usersnames', { actionName: actionName, usernames: usernames.join(', ') }
            t.text ' ' # Some translations didn't get the whitespace on the sentence above
            t.span '.bulk-list-option-other-members-link',
              onClick: (e) =>
                @setState showingMembersList: !@state.showingMembersList
                e.stopPropagation()
            , =>
              t.format 'others', { count: members.length - 2 }
              t.text ' ' # Some translations didn't get the whitespace on the sentence above

              if @state.showingMembersList
                t.format 'hide'
              else
                t.format 'show-all'

      t.div '.explanation-members-wrapper',
        class: t.classify 'disabled': (!@state.showingMembersList)
      , =>
        t.div '.quiet.bulk-list-option-explanation-members',
          onClick: (e) -> e.stopPropagation()
        , =>
          for member in members
            t.div ->
              t.text "#{ member.fullName } (#{ member.username })"



// WEBPACK FOOTER //
// ./app/scripts/views/enterprise/dashboard/bulk-actions/option-component.coffee